import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PieStatsComponent
  from './../Components/PieStatsComponent.jsx';
import {
  Col,
  Row
} from 'react-bootstrap';
import { scenarios as constants, installer as installerConstants } from './../helpers';

import {
  getScenariosBy,
  getPieStatsTitlesFunc,
  metricsByJobIds,
} from './../reducers';

const RegressionPieStatsContainer =
({ chartWidth, scenariosByGroup, pieStatsTitles }) => {

  let pendingCharts = [];
  let currentWidth = 0;
  const charts = [];

  const keys = Object.keys(scenariosByGroup);
  for (let i = 0; i < keys.length; i++) {
    if (pieStatsTitles[i] === '')
    {
      continue;
    }
    const title = pieStatsTitles[i];
    const groupBy = keys[i];

    const pieData = constants.getStateCounts(scenariosByGroup[groupBy]);
    const panelStyle = constants.getPanelStyle(scenariosByGroup[groupBy]);
    const totalTestsCount = pieData.reduce((total, current) => total + current);
    if (totalTestsCount > 0) {
      pendingCharts.push(
        <Col key={i} md={chartWidth} style={{ 'marginBottom':'30px' }} >
          <PieStatsComponent
            {...panelStyle} pieData={pieData}
            title={title + ' (Jobs: ' + totalTestsCount +
            (pieData[1] > 0 ? (', Failed: ' + pieData[1]) : '') + ')'}
          />
        </Col>
      );
      currentWidth += chartWidth;
    }
    if (currentWidth === 12 || currentWidth + chartWidth > 12 ||
          i === keys.length - 1) {
      const paddingWidth = Math.trunc((12 - currentWidth) / 2);
      let padding = null;

      if (paddingWidth > 1) {
        padding = (<Col md={paddingWidth} />);
      }

      charts.push(
        <Row key={i}>
          {padding}
          {pendingCharts}
        </Row>
      );

      pendingCharts = [];
      currentWidth = 0;
    }
  }

  return (
    <div>
      {charts}
    </div>
  );
};

RegressionPieStatsContainer.propTypes = {
  chartWidth: PropTypes.number.isRequired,
  scenariosByGroup: PropTypes.object.isRequired,
  pieStatsTitles: PropTypes.array
};

export const mapStateToProps = (state, ownProps) => {
  const scenariosBy = getScenariosBy(state);
  const metrics = metricsByJobIds(state);
  let scenariosByGroup;

  switch (scenariosBy)
  {
    case constants.scenariosByPlatform:
      scenariosByGroup = ownProps.scenarios ?
        constants.getScenariosByPlatform(ownProps.scenarios) : {};
      break;
    case constants.scenariosByJobType:
      scenariosByGroup = ownProps.scenarios ?
        constants.getScenariosByJobType(ownProps.scenarios) : {};
      break;
    case constants.scenariosByImageName:
      scenariosByGroup = ownProps.scenarios ?
        constants.getScenariosByImageName(ownProps.scenarios) : {};
      break;
    case constants.scenariosByInstaller:
      scenariosByGroup = {};
      if (ownProps.scenarios) {
        const filteredMetrics = [];
        ownProps.scenarios.forEach(scenario => {
          const metric = metrics[scenario.runner];
          if (typeof(metric) !== 'undefined') {
            filteredMetrics.push({
              'INSTALL_SUCCESS':
                ((metric[installerConstants.FILE_COMPARE_RESULT] &&
                  metric[installerConstants.INSTALLER_TEST_RESULT]) ?
                  ((metric[installerConstants.FILE_COMPARE_RESULT]
                    .toUpperCase() === 'TRUE' &&
                    metric[installerConstants.INSTALLER_TEST_RESULT]
                      .toUpperCase() === 'TRUE') ?
                    'Pass' :
                    'Fail') : ''),
              'status': scenario.status
            });
          }
          else {
            filteredMetrics.push({ status: scenario.status });
          }
        });

        if (filteredMetrics.length > 0) {
          scenariosByGroup['Installer'] = filteredMetrics;
        }
      }
      break;
    default:
      break;
  }

  const pieStatsTitles = getPieStatsTitlesFunc(state, scenariosByGroup);
  return { scenariosByGroup, pieStatsTitles };
};

export default connect(
  mapStateToProps
)(RegressionPieStatsContainer);


// WEBPACK FOOTER //
// src/Containers/RegressionPieStatsContainer.jsx